import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
const twMerge = extendTailwindMerge({
    extend: {
        // `font-display` es una familia tipográfica del preset Paguz (no un tamaño).
        classGroups: { 'font-family': ['font-display'] },
    },
});
/** Combina clases condicionales y resuelve conflictos de Tailwind. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=utils.js.map